import React from "react";
import HoverIconButton from "components/HoverIconButton";
import { COLORS } from "utils/styles";
import { TOOLTIP_POSITION } from "utils/constants/ui";
import { useSectionConfig } from "utils/hooks/editor";
import { usePageBuilderContext } from "utils/context";
import { useModelQueryId } from "utils/hooks";
import { APPLICATION, SECTION, PAGE } from "utils/constants/models";
import Link from "next/link";
import { interpolateRouteWithParams } from "utils/route";
import PATHS from "utils/paths";
import Analytics, { CLICK_EDITOR_SECTION_NAV } from "utils/analytics";
import { BLOCK_SECTION_NAV } from "utils/constants/builder";

const SectionNav = () => {
  const pageContext = usePageBuilderContext();
  const tracking = pageContext ? pageContext.tracking : {};

  const currentSectionId = useModelQueryId(SECTION);
  const appId = useModelQueryId(APPLICATION);
  const pageId = useModelQueryId(PAGE);
  const contextSections = useSectionConfig();

  const sectionNodes = contextSections.map(({ uid, label }, configIx) => {
    const isActive = uid === currentSectionId;

    const destination = interpolateRouteWithParams(
      PATHS.APPLICATIONS_PAGES_SHOW_SECTION,
      {
        application: {
          uuid: appId
        },
        page: {
          uuid: pageId
        },
        section: {
          uuid: uid
        }
      }
    );

    return (
      <div
        key={configIx}
        style={{ outline: "none" }}
        className={
          "pa0 ma0 items-center flex pa2 w-100 dib items-center justify-center bn bg-white bh--inset"
        }
      >
        <div className="bb hairline-1 h-100 w-100 flex justify-center pb3">
          <Link href={destination}>
            <HoverIconButton
              tooltip={label}
              position={TOOLTIP_POSITION.RIGHT}
              onClick={() => {
                Analytics.track(CLICK_EDITOR_SECTION_NAV, {
                  ...tracking,
                  section: uid
                });
              }}
              size={24}
              type={uid}
              color={isActive ? COLORS.blue : COLORS.secondary}
            />
          </Link>
        </div>
      </div>
    );
  });

  return (
    <div
      style={{ width: BLOCK_SECTION_NAV }}
      className="h-100 pt2 bg-white bh--inset"
    >
      {sectionNodes}
    </div>
  );
};

export default SectionNav;
